import { createAction } from '@ngrx/store';

export * from './lead-todo-generated.actions';
export const upsertOneLeadTodoSuccess = createAction('[LeadTodo] upsert one LeadTodo Success');
